<template>
  <div>
    <div class="sc-message">

      <div class="sc-message--content" :class="{
        sent: message.author === 'me',
        received: message.author !== 'me' && message.type !== 'system',
        system: message.type === 'system'
      }">
        <!-- v-if="message.type !== 'system'" -->
        <!-- v-if="(message.type !== 'system' && message.head_and_time == null) || (message.type == 'rich' && message.head_and_time === 0)" -->

        <div>
          <div v-if="message.type !== 'system' && message.type !== 'takeOverMessage'" :title="authorName" class="sc-message--avatar" :style="{
            backgroundImage: `url(${(message.type !== 'system' && message.head_and_time == null) || (message.type == 'rich' && message.head_and_time === 0) ? chatImageUrl : ''})`
          }"></div>
          <div v-if="chatImageUrl === '/static/tickets_cs.png'" class="cs-title">
            客服
          </div>
        </div>
        
        <TextMessage v-if="message.type === 'text' && context === null" :data="message.data" :messageStyling="messageStyling"
          :message="message" :multipleType="false" />

          <!-- :messageColors="determineMessageColors()" -->
          
        <MarkDownTextMessage  v-else-if="message.type === 'mark'" :data="message.data" :messageStyling="messageStyling"
          :message="message" :multipleType="false" />
  
        <CarouselMessageCard v-else-if="message.type === 'text' && context.msgType === 'carouselTextCards'" :message="message" @tag-clicked="tagClicked" />
          
        <TextMessage v-else-if="message.type === 'rich' && context.msgType == 'text'" :data="message.data"
          :messageStyling="messageStyling" :message="message" :multipleType="true" />

        <VideoCardMessage v-else-if="message.type === 'rich' && context.msgType == 'videoCards'" :data="message"
          @tag-clicked="tagClicked" />
        <ImageMessage v-else-if="message.type === 'rich' && context.msgType == 'image'" :message="message" />
        <AudioCardsMessage v-else-if="message.type === 'rich' && context.msgType == 'audioCards'" :message="message"
          :vsName="vsName" @tag-clicked="tagClicked" />
        <GeneralCardsMessage v-else-if="message.type === 'rich' && context.msgType == 'generalCards'" :message="message"
          :projectId="projectId" :isMobile="isMobile" :isApp="isApp" :returnJSONtoMobile="returnJSONtoMobile"
          @tag-clicked="tagClicked" />
        <TextCardsMessage v-else-if="message.type === 'rich' && context.msgType == 'textCards'" :message="message"
          :isMobile="isMobile" @tag-clicked="tagClicked" />
        <QuickReplayMessage v-else-if="message.type === 'rich' && context.msgType == 'quickReplay'" :message="message"
          :isMobile="isMobile" @tag-clicked="tagClicked" />
        <HtmlMessage v-else-if="message.type === 'rich' && context.msgType == 'html'" :message="message"
          @tag-clicked="tagClicked" />
        <TakeOverMessage v-else-if="message.type === 'takeOverMessage'" :message="message" />
        <EmojiMessage v-else-if="message.type === 'emoji'" :data="message.data" />
        <div class="card" v-else-if="message.type === 'card'" :data="message.data">
          <img src="https://uc.udn.com.tw/upf/news/2017/images/icon_APP.jpg" alt="Avatar" style="width:100%">
          <div class="container">
            <h4>
              <b>{{ message.data.text }}</b>
            </h4>
          </div>
        </div>
        <FileMessage v-else-if="message.type === 'file'" :data="message.data" :message="message" />
        <!-- :messageColors="determineMessageColors()" -->
        <TypingMessage v-else-if="message.type === 'typing'" :message="message" />
        <!-- :messageColors="determineMessageColors()" -->
        <SystemMessage v-else-if="message.type === 'system'" :data="message.data" :message="message" />
        <!-- :messageColors="determineMessageColors()" -->
        <TextMessage v-else :data="message.data" :messageStyling="messageStyling"
        :message="message" :multipleType="false" />
    
      </div>
    </div>
    <!-- <div v-if="(message.type !== 'typing' && message.head_and_time == null) || (message.type == 'rich' && message.head_and_time === 1)" :class="theClass">{{new Date(message.requestTime * 1000).toLocaleString()}}</div> -->
    <div v-if="message.type !== 'takeOverMessage'" :class="theClass">{{
      (message.type !== 'typing' && message.head_and_time == null) || (message.type == 'rich' && message.head_and_time ===
        1) ? new Date(message.requestTime * 1000).toLocaleString() : "" }}</div>
  </div>
</template>

<script>
import TextMessage from "./TextMessage.vue"
import MarkDownTextMessage from "./MarkDownTextMessage.vue"
import FileMessage from "./FileMessage.vue"
import EmojiMessage from "./EmojiMessage.vue"
import TypingMessage from "./TypingMessage.vue"
import SystemMessage from "./SystemMessage.vue"
import VideoCardMessage from "./VideoCardMessage.vue"
import AudioCardsMessage from "./AudioCardsMessage.vue"
import GeneralCardsMessage from "./GeneralCardsMessage.vue"
import TextCardsMessage from "./TextCardsMessage.vue"
import QuickReplayMessage from "./QuickReplayMessage.vue"
import ImageMessage from "./ImageMessage.vue"
import HtmlMessage from "./HtmlMessage.vue"
import TakeOverMessage from "./TakeOverMessage.vue"
import chatIcon from "./assets/chat-icon.svg"
import CarouselMessageCard from "./CarouselMessageCard.vue"

export default {
  data() {
    return {}
  },
  components: {
    TextMessage,
    MarkDownTextMessage,
    FileMessage,
    EmojiMessage,
    TypingMessage,
    SystemMessage,
    VideoCardMessage,
    AudioCardsMessage,
    ImageMessage,
    GeneralCardsMessage,
    TextCardsMessage,
    QuickReplayMessage,
    HtmlMessage,
    TakeOverMessage,
    CarouselMessageCard
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    chatImageUrl: {
      type: String,
      default: chatIcon
    },
    // colors: {
    //   type: Object,
    //   required: true
    // },
    authorName: {
      type: String
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    projectId: {
      type: String,
      default: () => ''
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    isApp: {
      type: Boolean,
      default: false
    },
    returnJSONtoMobile: {
      type: Function,
      required: true
    }
  },
  computed: {
    vsName() {
      return 'audio' + Math.floor(Math.random() * 10000)
    },
    context() {
      if (this.message.msgJson !== undefined) {
        // this.message.msgJson.msgType = 'textlCards';

        return JSON.parse(this.message.msgJson)
      } else {
        // console.log('20191008 2')
        return { msgType: 'text' }
      }
    },
    theClass() {
      return this.message.author === 'me' ? 'client-time' : 'server-time'
    }
  },
  methods: {
    tagClicked(value) {
      this.$emit("tag-clicked", value)
    },
  }
}
</script>
<style >
@import "./styles/message.css";
</style>


// WEBPACK FOOTER //
// src/components/beautiful-chat/Message.vue